import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-required-message',
  template: `
    <span class="required-indication" style="width:auto;">
      <span class="requiredMsg">* </span>
      <span>Indicates required field</span>
    </span>
  `
})
export class RequiredMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
